import dayjs from 'dayjs';

export const VERDICTS = [
  { key: 'CORRECT', label: 'Correct', variant: 'success' },
  { key: 'WRONG', label: 'Wrong', variant: 'danger' },
  { key: 'UNSURE', label: 'Unsure', variant: 'warning' },
];

// The column's width; the backend refuses a longer note.
export const REVIEW_NOTE_MAX_LENGTH = 255;

export const REVIEWED_FILTERS = [
  { value: 'all', label: 'All rows' },
  { value: 'pending', label: 'Not reviewed' },
  { value: 'reviewed', label: 'Reviewed' },
];

export const packOf = packSize => packSize || 'N/A';

export const verdictOf = key => VERDICTS.find(verdict => verdict.key === key);

export function countBy(rows, key) {
  return rows.reduce((counts, row) => {
    counts[row[key]] = (counts[row[key]] || 0) + 1;
    return counts;
  }, {});
}

export function runLabel(run) {
  const date = run.completed_at ? dayjs(run.completed_at).format('MM/DD/YY') : '';
  const kind = run.blind_back_test ? 'blind back-test' : 'live';
  const assessed = Number(run.products_assessed || 0).toLocaleString('en-US');
  const vendor = `${run.vendor_name || 'vendor'} (${run.global_vendor_id})`;
  return `Run ${run.id} · ${date} · ${vendor} · ${kind} · ${assessed} products`;
}

export function filterRows(rows, reviews, { action, reviewed }) {
  return rows.filter(
    row =>
      (!action || row.action === action) &&
      (reviewed === 'all' ||
        (reviewed === 'reviewed') === Boolean(reviews[row.fsa_vendor_product_id])),
  );
}

// Highest GMV first, so reviewers reach the products that matter most; rows with none go last.
export const byGmvDescending = (a, b) => (b.gmv ?? -1) - (a.gmv ?? -1);

// The products a row names: its target, the duplicate QA-3 found, and the shortlist it was weighed
// against (QA-3's own when it searched, else the pick's).
export const productUrl = (globalProductId, productId, productType) =>
  globalProductId && productId
    ? `/global-product-detail/${globalProductId}/${productId}/${productType}`
    : null;

export const recordUrl = (path, id) => (id ? `/enrich-products/${path}/${id}` : null);
